import { ReactNode } from 'react';

import { cn } from '@mint-lib/tw-utils';

import { useHasSufficientViewportHeight } from '../../hooks/useHasSufficientViewportHeight.js';

export const MainLayout = ({ children }: { children: ReactNode }) => {
  const hasSufficientViewportHeight = useHasSufficientViewportHeight();

  return (
    <div
      id="import-hub-layout"
      className={cn('grey-background flex h-full flex-col', {
        'min-h-full': !hasSufficientViewportHeight,
      })}
    >
      {children}
      <div className="spacer pb-6" />
    </div>
  );
};
